import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';
import { makeStyles } from '@material-ui/core/styles';

const lightTheme = {
  root: {
    color: TextColors.dark,
    '& $listButtonIconMobile': {
      color: SecondaryColors.dark,
    },
    '& $sortBy': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light2),
    },
    '& $sortByButton': {
      color: TextColors.dark,
    },
    '& $menuIcon': {
      color: SecondaryColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    color: TextColors.light,
    '& $listButtonIconMobile': {
      color: SecondaryColors.main,
    },
    '& $sortBy': {
      color: hexToRGBA(TextColors.light, TextOpacities.dark2),
    },
    '& $sortByButton': {
      color: TextColors.light,
    },
    '& $menuIcon': {
      color: SecondaryColors.main,
    },
  },
};

export const classesPdf = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
  },
  filters: {
    marginBottom: '10px',
  },
  title: {
    margin: 0,
    fontSize: '20px',
    lineHeight: 1,
  },
  logo: {
    margin: 0,
    height: '20px',
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      display: 'flex',
      justifyContent: 'space-between',
    },
    print: {
      visibility: 'collapse',

      '@media print': {
        visibility: 'visible',
        size: 'landscape',
        width: 'fit-content',
      },
    },
    list: {
      listStyle: 'none',
      display: 'flex',
      justifyContent: 'flex-end',
      '& li': {
        fontSize: '.85em',
        marginLeft: muiTheme.spacing(2),
      },

      [muiTheme.breakpoints.down('sm')]: {
        padding: muiTheme.spacing(0, 2),
        '& li': {
          flex: '1 1 33.33%',
        },
      },
    },
    listButton: {
      width: '100%',
      height: '100%',
      color: 'inherit',

      [muiTheme.breakpoints.down('sm')]: {
        background: '#fff',
        padding: muiTheme.spacing(1, 1, 1, 0.75),
      },
    },
    listButtonIconMobile: {
      display: 'block !important',
      margin: '0 auto',

      [muiTheme.breakpoints.up('sm')]: {
        display: 'none !important',
      },
    },
    listButtonIconEndMobile: {
      fontSize: 'inherit',
      verticalAlign: 'middle',

      [muiTheme.breakpoints.down('sm')]: {
        fontSize: '1em !important',
      },
    },
    listButtonIcon: {
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none !important',
      },
    },
    sortBy: {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 200px',
      marginBottom: muiTheme.spacing(0.5),
    },
    sortByButton: {},
    menuIcon: {},
  }),
  { name: 'GenSDLPrintToolBar' },
);

export default useStyles;
